<script setup lang="ts">

import Skeleton from '@/application/components/ui/Skeleton.vue';
import CardGrid from '@/contracts/components/CardGrid.vue';
</script>

<template>
  <div class="flex flex-col gap-12 mt-8">
    <div class="flex flex-col md:flex-row justify-between">
      <Skeleton gradient class="w-full md:w-72 h-9" />
      <Skeleton gradient class="md:hidden w-2/3 h-6 mt-5" />
      <Skeleton gradient class="hidden md:block w-36 h-9" />
    </div>
    <CardGrid>
      <Skeleton gradient class="h-32" />
      <Skeleton gradient class="h-32" />
    </CardGrid>
  </div>
</template>
